import { useLingui } from '@lingui/react/macro';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import type { PageLayout, RenderPageProps } from '@react-pdf-viewer/core';
import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';

import { colors } from '../../../utils/theme';
import VideaLogoLarge from '../../elements/icon/svgs/VideaLogoLarge';
import { ABOUT_IFU_PDF_URLS } from '../pdfReader/pdfConstants';

import { CustomPageLayer } from './CustomPageLayer';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 30,
    fontWeight: 400,
    color: colors.WHITE,
    fontFamily: 'Montserrat',
    marginLeft: 50,
  },
  header: {
    height: 104,
    backgroundColor: colors.HEADER_BG_COLOR,
    paddingRight: 20,
  },
  pdfContainer: {
    width: '70%',
    margin: 'auto',
    height: '80%',
  },
}));

interface Props {
  pdfUrl: string;
}

export const PdfViewer = ({ pdfUrl }: Props) => {
  const classes = useStyles();
  const { t } = useLingui();
  const pdfjsVersion = `3.11.174`;
  const pageLayout: PageLayout = {
    buildPageStyles: () => ({
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      paddingTop: '30px',
      border: '1px solid #ddd',
    }),
  };
  const renderPage = (props: RenderPageProps) => (
    <CustomPageLayer renderPageProps={props} />
  );

  const getPdfTitleByUrl = (pdf: string) => {
    const pdfKey = Object.keys(ABOUT_IFU_PDF_URLS).find(
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      (key) => ABOUT_IFU_PDF_URLS[key] === pdf,
    );

    let titleHeader = '';
    let titleName = '';
    if (pdfKey?.includes('ABOUT')) {
      titleHeader = t`About`;
    } else if (pdfKey?.includes('IFU')) {
      titleHeader = t`IFU`;
    } else if (pdf.includes('Privacy-Policy')) {
      titleHeader = t`Privacy Policy`;
    }

    if (pdfKey?.includes('VCA')) {
      titleName = t`Videa Caries Assist`;
    } else if (pdfKey?.includes('VPA')) {
      titleName = t`Videa Perio Assist`;
    } else if (pdfKey?.includes('VDA')) {
      titleName = t`Videa Dental AI`;
    } else if (pdfKey?.includes('DSS')) {
      titleName = t`Videa Decision Support Software`;
    } else if (pdfKey?.includes('SEG')) {
      titleName = t`Patient View and Videa Segmentation`;
    }
    return titleHeader + (titleName ? ` - ${titleName}` : '');
  };

  return (
    <Box display="flex" flexDirection="column" height={1} width={1}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        width={1}
        className={classes.header}
      >
        <Typography className={classes.title}>
          {getPdfTitleByUrl(pdfUrl)}
        </Typography>
        <VideaLogoLarge />
      </Box>
      <Box height={1} className={classes.pdfContainer}>
        <Worker
          workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}
        >
          <Viewer
            fileUrl={pdfUrl}
            pageLayout={pageLayout}
            defaultScale={SpecialZoomLevel.PageWidth}
            renderPage={renderPage}
          />
        </Worker>
      </Box>
    </Box>
  );
};
